module.exports = __webpack_public_path__ + "static/media/save-popup.72116a3e.png";